<template>
  <div class="benefits">
    <h3 class="bold">Benefits</h3>
    <ul
      class="benefits-text-box"
      :style="{ width: `${benefitsWidth || 100}%` }"
    >
      <li v-for="(key, index) in benefits" :key="key + index" class="list">
        {{ key }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ProductBenefitsComponent',
  props: {
    benefits: {
      type: Array,
      required: true
    },
    benefitsWidth: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.benefits {
  align-self: flex-start;
  h3 {
    margin: @space-large 0;
  }
  .list {
    width: 100%;
    padding-bottom: @space-base;
  }
  .benefits-text-box {
    padding-left: @space-large;
    font-size: @font-size;
  }
}
</style>
